export const DARK_GREY_BLUE = '#2d425d';
export const BLACK_10 = '#e6e6e6';
